// extracted by mini-css-extract-plugin
export var csatScore = "_n9-5";
export var header = "_n9-1";
export var panelWrapper = "_n9-2";
export var postPreview = "_n9-3";
export var rightContent = "_n9-0";
export var wrappingText = "_n9-4";